import type { ZIndices } from '@trmediaab/zebra';

const zIndices: ZIndices = {
  modal: 100,
};

export default zIndices;
